
import { farmPriceService } from '../farmPriceService';
import { distributionCenterPriceService } from '../distributionCenterPriceService';
import { localShopPriceService } from '../localShopPriceService';
import { sundayMarketPriceService } from '../sundayMarketPriceService';
import { supermarketPriceService } from '../supermarketPriceService';
import { ecommercePriceService } from '../ecommercePriceService';
import { getCanonicalProductName, getCanonicalProductNames } from './productNameMapping';

export async function getAllUniqueProducts(): Promise<string[]> {
  const allProducts = new Set<string>();

  // Collect products from all services using their specific method names
  const services = [
    { key: 'farm-prices', service: farmPriceService, method: 'getFarmPrices' },
    { key: 'distribution-center', service: distributionCenterPriceService, method: 'getDistributionCenterPrices' },
    { key: 'local-shops', service: localShopPriceService, method: 'getLocalShopPrices' },
    { key: 'sunday-market', service: sundayMarketPriceService, method: 'getUniqueProducts' },
    { key: 'supermarket', service: supermarketPriceService, method: 'getUniqueProducts' },
    { key: 'ecommerce', service: ecommercePriceService, method: 'getUniqueProducts' },
  ];

  for (const { key, service, method } of services) {
    try {
      if (method === 'getUniqueProducts' && 'getUniqueProducts' in service) {
        const products = await service.getUniqueProducts();
        products.forEach(product => {
          const canonical = getCanonicalProductName(product);
          allProducts.add(canonical);
        });
      } else {
        // For services without getUniqueProducts, fetch all data and extract unique products
        const data = await (service as any)[method]({});
        const productNames = data
          .map((item: any) => item.product_name)
          .filter((name: any): name is string => typeof name === 'string');
        productNames.forEach(product => {
          const canonical = getCanonicalProductName(product);
          allProducts.add(canonical);
        });
      }
    } catch (error) {
      console.error(`Error fetching products from ${key}:`, error);
    }
  }

  // Add all canonical product names to ensure complete coverage
  getCanonicalProductNames().forEach(name => allProducts.add(name));

  return Array.from(allProducts).sort();
}
